interface Props {
  image: string;
  alt: string;
  caption: string;
  pixelWidth?: number;
  url?: string;
}

export function InlineImage({ image, pixelWidth, alt, caption, url }: Props) {
  const imageElement = (
    <figure style={{ width: "100%", margin: url ? "0" : "0 0 20px" }}>
      <picture style={{ display: "block", borderRadius: "4px", overflow: "hidden" }}>
        <source srcSet={`${image}/feed`} type="image/webp" />
        <img
          style={{
            margin: "0 auto",
            borderRadius: "4px",
            display: "block",
            objectFit: "contain",
            maxWidth: pixelWidth || "100%",
          }}
          src={`${image}/feed`}
          alt={alt}
        />
      </picture>
      {caption && (
        <figcaption
          style={{
            textDecoration: "none",
            marginTop: "8px",
            fontStyle: "italic",
            textAlign: "center",
            fontSize: "12px",
            width: "100%",
          }}
        >
          {caption}
        </figcaption>
      )}
    </figure>
  );

  if (!url) {
    return imageElement;
  }

  return (
    <a href={url} target="_blank" style={{ display: "block", marginBottom: "20px" }} rel="noreferrer">
      {imageElement}
    </a>
  );
}
